import React, { useState } from "react";
import DropdownList from "../../../../Patient/partial/DropdownList";
import { toast } from "react-toastify";

const NewQuestion = ({ onSubmit, onCancel, categories }) => {
    //local state
    const items = categories || [];
    const [category, setCategory] = useState(null);
    const [many, setMany] = useState(false);

    // create reference
    const nameRef = React.createRef();
    return (
        <form
            method="POST"
            onSubmit={e => {
                e.preventDefault();
                const name = nameRef.current.value;
                if (name) {
                    onSubmit({
                        name,
                        allowMultipleSelection: many,
                        category: category.id
                    });

                    // clear form
                    nameRef.current.value = "";
                } else {
                    toast.error("Name and category are required!");
                    return;
                }
            }}
        >
            <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input type="text" ref={nameRef} className="form-control input-height" id="name" name="question" placeholder="enter question's name" />
            </div>
            <div className="form-group">
                <DropdownList items={items} title="Category *" onSelect={item => setCategory(item)} />
            </div>

            <div className="form-group">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" onChange={e => setMany(e.target.checked)} id="customCheck1" />
                    <label class="custom-control-label" htmlFor="customCheck1">
                        Allow Multiple Selection
                    </label>
                </div>
            </div>
            <div className="text-center m-b-20 m-t-20">
                <button type="button" onClick={() => onCancel()} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 margin-right-10 btn-circle">
                    <i className="material-icons text-danger">close</i> Close
                </button>
                <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-t-10 btn-success btn-circle">
                    Submit Question <i className="material-icons">arrow_right_alt</i>
                </button>
            </div>
        </form>
    );
};
export default NewQuestion;
